// extracted by mini-css-extract-plugin
module.exports = {"optionContainer":"styles__optionContainer___2XIxi","optionTitle":"styles__optionTitle___3A2Q1","optionDescription":"styles__optionDescription___3aJ9s"};